import { Component, Directive, OnInit, TemplateRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ScStepService } from '../sc-step.service';
import { ScTemplateService } from '../sc-template.service';

/* eslint-disable @angular-eslint/directive-selector */
/* eslint-disable max-classes-per-file */

@Directive({
  selector: '[step-footer-template]'
})
export class ScStepFooterDirective {
  constructor(private _templateRef: TemplateRef<any>, private _templateService: ScTemplateService) {
    const viewRef = this._templateRef.createEmbeddedView({});
    this._templateService.setFooter({
      isEmpty: viewRef.rootNodes.length < 1,
      template: this._templateRef
    });
  }
}

@Directive({
  selector: '[step-header-template]'
})
export class ScStepHeaderDirective {
  constructor(private _templateRef: TemplateRef<any>, private _templateService: ScTemplateService) {
    const viewRef = this._templateRef.createEmbeddedView({});
    this._templateService.setHeader({
      isEmpty: viewRef.rootNodes.length < 1,
      template: this._templateRef
    });
  }
}

// @Directive({
//   selector: '[step-content]'
// })
// export class AbleraStepContentDirective {
//   constructor(
//     private _templateRef: TemplateRef<any>,
//     private _templateService: TemplateService,
//     private _stepService: StepService
//   ) {
//     const viewRef = this._templateRef.createEmbeddedView({});

//   }
// }

@Component({
  selector: 'sc-step',
  templateUrl: './sc-step.component.html',
  styleUrls: ['./sc-step.component.scss']
})
export class ScStepComponent implements OnInit {
  public form: FormGroup;
  public stepIndex: number;
  public route: string;

  constructor(private _stepService: ScStepService) {}

  ngOnInit() {
    const step = this._stepService.getStep();
    this.stepIndex = step.stepIndex;
    this.route = step.route;
    this.form = step.form;
    this.form.reset(step.form.value);
  }
}
